import { render, staticRenderFns } from "./KeyRelays.vue?vue&type=template&id=61947752&"
import script from "./KeyRelays.vue?vue&type=script&lang=ts&"
export * from "./KeyRelays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports